<template>
  <section class="hack-partners-section">
    <div class="hack-partners-container">

      <!-- Grille avec cadre pointillé -->
      <div class="hack-logos-wrapper">
        <span class="hack-title-text">Ils nous accompagnes</span>
        <div class="hack-logos-grid">
          <div
            v-for="(partner, index) in partners"
            :key="index"
            class="hack-logo-cell"
            @click="openLink(partner.url)"
          >
            <img :src="partner.logo" :alt="partner.name" class="hack-logo-img" :style="partner.imgStyle" />
          </div>
        </div>
      </div>

      <!-- Bas : texte centré + bouton -->
      <div class="hack-bottom">
        <p class="hack-bottom-text">
          Positionnez votre établissement à l'avant-garde de l'innovation bitcoin/blockchain<br/>
          et offrez à vos étudiants une formation aux technologies de demain.
        </p>
        <button class="hack-cta-btn" @click="openGoogleDoc">Devenez partenaire</button>
      </div>

    </div>
  </section>
</template>

<script>
import { partnerLogosStatic } from "@/data/partners.js";

export default {
  name: "PartnersHackathon",
  data() {
    return {
      partners: [
        { name: "Bitcoin Bénin",     logo: partnerLogosStatic.bitcoinBenin,   url: "bitcoinbenin.org",               },
        { name: "Plan B Network",    logo: partnerLogosStatic.planBNetwork,   url: "https://planb.academy/",         },
        { name: "IziChange",         logo: partnerLogosStatic.izichange,      url: "izichange.com",                  },
        { name: "Btrust",            logo: partnerLogosStatic.btrust,         url: "https://www.btrust.tech/",       },
        { name: "Trezor",            logo: partnerLogosStatic.trezor,         url: "https://trezor.io/",             },
        { name: "Epitech",           logo: partnerLogosStatic.epitech,        url: "https://www.epitech.eu/",          },
        { name: "BTCKids",           logo: partnerLogosStatic.btckids,        url: "https://btckids.org/",             },
        { name: "OpenCom",           logo: partnerLogosStatic.OpenCom,         url: "https://www.opencom.bj/",          },
        { name: "Demaf Digital",     logo: partnerLogosStatic.demafDigital,   url: "#",                                },
        { name: "Wallet of Satoshi", logo: partnerLogosStatic.walletOfSatoshi,url: "https://walletofsatoshi.com/",    },
        { name: "Zeus",              logo: partnerLogosStatic.zeus,           url: "https://zeusln.com/",             },
        { name: "Blink",             logo: partnerLogosStatic.blink,          url: "https://blink.sv/",                },
        { name: "Machankura",        logo: partnerLogosStatic.machankura,     url: "https://machankura.com/",          },
        { name: "Bitnob",            logo: partnerLogosStatic.bitnob,         url: "https://bitnob.com/",              },
        { name: "AlbyGo",            logo: partnerLogosStatic.albygo,         url: "https://getalby.com/",             },
      ],
    }
  },
  methods: {
    openLink(url) {
      if (!url || url === "#") return
      window.open(url, "_blank")
    },
    openGoogleDoc() {
      this.$router.push("/partners/apply")
    },
  }
}
</script>

<style scoped>
.hack-partners-section {
  background: #fff;
  padding: 64px 0 80px;
  overflow-x: hidden;
}

.hack-partners-container {
  max-width: 1630px;
  margin: 0 auto;
  padding: 0 64px;
  box-sizing: border-box;
}

/* Cadre pointillé */
.hack-logos-wrapper {
  width: 100%;
  border: 1px dashed #000000BA;
  margin: 0 0 40px;
  padding: 58px 48px 48px;
  position: relative;
  box-sizing: border-box;
}

.hack-title-text {
  position: absolute;
  top: -11px;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 0 12px;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #6B7280;
  white-space: nowrap;
}

/* Grille logos */
.hack-logos-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  width: 100%;
}

.hack-logo-cell {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F5F4F2;
  padding: 20px 32px;
  cursor: pointer;
  transition: background 0.15s ease;
  box-sizing: border-box;
  overflow: hidden;
}

.hack-logo-cell:hover {
  background: #EBEBEB;
}

.hack-logo-img {
  width: auto;
  height: auto;
  object-fit: contain;
  filter: grayscale(10%);
  transition: all 0.3s ease;
}

.hack-logo-cell:hover .hack-logo-img {
  filter: grayscale(0%);
}

/* Bas */
.hack-bottom {
  text-align: center;
}

.hack-bottom-text {
  font-family: 'DM Sans', sans-serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 33px;
  letter-spacing: 0%;
  text-align: center;
  color: #05246A;
  margin: 0 0 28px;
}

.hack-cta-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #24D164;
  color: #111827;
  font-family: 'DM Sans', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  padding: 16px 40px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.2s;
}

.hack-cta-btn:hover {
  background: #1EBA57;
}

/* Responsive */
@media (max-width: 1024px) {
  .hack-logos-grid { grid-template-columns: repeat(4, 1fr); }
}

@media (max-width: 768px) {
  .hack-partners-container { padding: 0 24px; }
  .hack-logos-wrapper { padding: 48px 24px 32px; }
  .hack-logos-grid { grid-template-columns: repeat(3, 1fr); }
}

@media (max-width: 640px) {
  .hack-logos-grid { grid-template-columns: repeat(2, 1fr); }
  .hack-logo-cell { height: 80px; }
}
</style>
